const release = '0.11.7'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js